import { Role } from "./role.model";

export class Invitation {
  id: string;
  email: string;
  roles: Role[];
  created_at?: string;
  expires_at?: string;
}
